<template>
  <PopUp
    :model-value="modelValue"
    size="lg"
    :dark="true"
    :close-on-overlay="closeOnOverlay"
    @update:model-value="$emit('update:modelValue', $event)"
    @close="$emit('close')"
  >
    <div class="p-10 space-y-6">
      <button
        v-if="showCloseButton"
        class="absolute right-6 top-6 inline-flex h-12 w-12 items-center justify-center rounded-full bg-slate-100 text-slate-500 transition hover:bg-slate-200 hover:text-slate-700"
        type="button"
        @click="emitClose"
      >
        <span class="sr-only">Close</span>
        <img :src="closeIcon" alt="" class="h-6 w-6" />
      </button>

      <div class="space-y-3 text-center">
        <slot name="title">
          <h3 v-if="title" class="text-[2.4rem] font-semibold text-slate-900">
            {{ title }}
          </h3>
        </slot>
        <slot name="description">
          <p v-if="message" class="text-[1.6rem] leading-relaxed text-slate-600">
            {{ message }}
          </p>
        </slot>
      </div>

      <slot />

      <div v-if="hasActions" class="flex flex-col gap-3 sm:flex-row sm:justify-center">
        <slot name="actions">
          <button
            v-if="secondaryText"
            type="button"
            class="inline-flex min-w-[8rem] items-center justify-center rounded-full border border-blue-600 px-6 py-3 text-sm font-semibold text-blue-600 transition hover:bg-blue-50"
            @click="handleSecondary"
          >
            {{ secondaryText }}
          </button>
          <button
            v-if="primaryText"
            type="button"
            class="inline-flex min-w-[8rem] items-center justify-center rounded-full bg-blue-600 px-6 py-3 text-sm font-semibold text-white transition hover:bg-blue-700"
            @click="handlePrimary"
          >
            {{ primaryText }}
          </button>
        </slot>
      </div>
    </div>
  </PopUp>
</template>

<script>
import { defineComponent } from "vue";
import CloseIcon from '@/assets/images/close-small.svg';
import PopUp from '@/components/popup/PopUp.vue';

export default defineComponent({
  name: "CoreModal",
  components: { PopUp },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    message: {
      type: String,
      default: "",
    },
    primaryText: {
      type: String,
      default: "",
    },
    secondaryText: {
      type: String,
      default: "",
    },
    closeOnOverlay: {
      type: Boolean,
      default: true,
    },
    showCloseButton: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["update:modelValue", "close", "primary", "secondary"],
  computed: {
    closeIcon() {
      return CloseIcon;
    },
    hasActions() {
      return Boolean(this.primaryText || this.secondaryText || this.$slots.actions);
    },
  },
  methods: {
    emitClose() {
      this.$emit("update:modelValue", false);
      this.$emit("close");
    },
    handlePrimary() {
      this.$emit("primary");
    },
    handleSecondary() {
      this.$emit("secondary");
    },
  },
});
</script>
